import { useState, useEffect, useRef } from 'react';
import { useNavigate } from "react-router-dom";
import { loginUser } from "../../redux/apiRequest";
import { useDispatch, useSelector } from "react-redux";

import './Login.scss';

import logo from '../../assets/logo.png';
import img1 from '../../assets/image/loginImg/image1.png';
import img2 from '../../assets/image/loginImg/image2.png';
import img3 from '../../assets/image/loginImg/image3.png';

const Login = () => {
  const currentUser = useSelector((state) => state.auth.login?.currentUser);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [index, setIndex] = useState(1);

  //Xử lý UX của thẻ input
  const [inputStates, setInputStates] = useState({
    username: false,
    password: false,
  });

  const inputsRef = useRef({
    username: null,
    password: null,
  });

  const handleFocus = (field) => {
    setInputStates((prev) => ({ ...prev, [field]: true }));
  };

  const handleBlur = (field) => {
    const value = inputsRef.current[field]?.value;
    if (!value) {
      setInputStates((prev) => ({ ...prev, [field]: false }));
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    loginUser({ username, password }, dispatch, navigate, (err) => setError(err.message)
    );
  };

  const moveSlider = (i) => {
    setIndex(i);
  };

  useEffect(() => {
    const id = setInterval(() => {
      setIndex((prev) => (prev % 3) + 1);
    }, 3000);
    return () => clearInterval(id);
  }, []);

  useEffect(() => {
    if (currentUser) {
      navigate("/");
    }
  }, [currentUser]);

  return (
    <main className="main">
      <div className="box">
        <div className="inner-box">
          <div className="forms-wrap">
            <form className="sign-in-form form" onSubmit={handleSubmit}>
              <div className="logo">
                {/* <img src={logo} alt="logo" /> */}
                <h4>Trung tâm ứng phó sự cố Môi trường Việt Nam
                </h4>
              </div>
              <div className="heading">
                <h2>Xin Chào!</h2>
                <h6>Hãy đăng nhập</h6>
              </div>
              <div className="actual-form">
                <div className="input-wrap">
                  <input
                    type="text"
                    ref={(el) => (inputsRef.current.username = el)}
                    className={`input-field ${inputStates.username ? "active" : ""}`}
                    onFocus={() => handleFocus("username")}
                    onBlur={() => handleBlur("username")}
                    value={username}
                    onChange={(e) => setUsername(e.target.value)}
                    required
                  />
                  <label className='label'>Tên đăng nhập</label>
                </div>
                <div className="input-wrap">
                  <input
                    type="password"
                    ref={(el) => (inputsRef.current.password = el)}
                    className={`input-field ${inputStates.password ? "active" : ""}`}
                    onFocus={() => handleFocus("password")}
                    onBlur={() => handleBlur("password")}
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                  />
                  <label className='label'>Mật khẩu</label>
                </div>
                {error && <span className="form-message">{error}</span>}
                <input type="submit" value="Đăng nhập" className="sign-btn" />
                <p className="text">
                  {/* Forgotten your password? <a href="#">Get help</a> signing in */}
                </p>
              </div>
            </form>
          </div>
          <div className="carousel">
            <div className="images-wrapper">
              <img src={img1} className={`image img-1${index === 1 ? ' show' : ''}`} alt="" />
              <img src={img2} className={`image img-2${index === 2 ? ' show' : ''}`} alt="" />
              <img src={img3} className={`image img-3${index === 3 ? ' show' : ''}`} alt="" />
            </div>
            <div className="text-slider">
              <div className="text-wrap">
                <div className="text-group" style={{ transform: `translateY(${-(index - 1) * 2.2}rem)` }}>
                  <h2>Ứng phó sự cố TD&HC</h2>
                  <h2>Giảng dạy chuyên nghiệp</h2>
                  <h2>Giáo trình bài bản</h2>
                </div>
              </div>
              <div className="bullets">
                <span className={index === 1 ? 'active' : ''} onClick={() => moveSlider(1)} data-value="1"></span>
                <span className={index === 2 ? 'active' : ''} onClick={() => moveSlider(2)} data-value="2"></span>
                <span className={index === 3 ? 'active' : ''} onClick={() => moveSlider(3)} data-value="3"></span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};

export default Login;
